module.exports = __webpack_public_path__ + "img/member_list.6ee3fdc0.svg";